export default "__VITE_ASSET__CwH6aXud__"